'use strict';
(function ($) {
	$.widget('Vetology.GooglePlacesSubmission', {
		"options": {
		},

		_init: function() {
			const o = this;

			o._addEventListeners();

		},

		_addEventListeners: function() {
			const o = this;
			this._on(this.element, {
				'click .submit-places-resubmission': o._submitPlacesResubmission
			});
		},

		_submitPlacesResubmission: function(event) {
			event.preventDefault();
			const form = document.querySelector('form.editForm');
			const nameSwitch = form.querySelector('input[name="ClinicName"]');
			const addr1Switch = form.querySelector('input[name="Address1"]');
			const addr2Switch = form.querySelector('input[name="Address2"]');
			const citySwitch = form.querySelector('input[name="City"]');
			const stateSwitch = form.querySelector('input[name="State"]');
			const zipSwitch = form.querySelector('input[name="Zip"]');

			const formData = new FormData();
			if (nameSwitch.checked) {
				const clinicName = form.querySelector('#clinic-name-value');
				formData.append('ClinicName', clinicName.textContent);
			}
			if (addr1Switch.checked) {
				const address1 = form.querySelector('#clinic-address1-value');
				formData.append('Address1', address1.textContent);
			}

			if (addr2Switch.checked) {
				const address2 = form.querySelector('#clinic-address2-value');
				formData.append('Address2', address2.textContent);
			}

			if (citySwitch.checked) {
				const city = form.querySelector('#clinic-city-value');
				formData.append('City', city.textContent);
			}

			if (stateSwitch.checked) {
				const state = form.querySelector('#clinic-state-value');
				formData.append('State', state.textContent);
			}

			if (zipSwitch.checked) {
				const zip = form.querySelector('#clinic-zip-value');
				formData.append('Zip', zip.textContent);
			}
			formData.append('_token', form.dataset.token);
			const clinicID = form.querySelector('input[name="ClinicID"]');
			formData.append('ClinicID', clinicID.value);

			fetch('/admin/resubmit-clinic-google-places', {
				method: 'post',
				body: formData
			}).then(response => {
				if (!response.ok) {
					toastr.error('We are unable to perform a google query at this time, please contact support');
				} else {
					return response.json();
				}
			}).then(data => {
				if (data.success) {
					const resultsElem = document.querySelector('#json-results');
					resultsElem.textContent = data.formatted_candidate;
					toastr.success('Successfully retrieved results from google places API for this clinic, and updated Clinic info');
				} else {
					toastr.error(data.error, 'A problem occurred when sending request to google places');
				}
			});
		}
	});
})(jQuery);
